<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
  import {computed, ref, onBeforeMount} from 'vue';
  import {getComponentConfig} from '@core/utils/getComponentConfig';

  interface Props {
    class?: string;
  }

  const props = withDefaults(defineProps<Props>(), {
    class: '',
  });

  const defaultConfig = {
    content: {
      base: 'card-content px-6 pt-2 pb-6 first:pt-6 text-base dark:text-gray-300',
    },
  };

  const config = ref(defaultConfig);

  onBeforeMount(async () => {
    config.value = await getComponentConfig('Card', defaultConfig);
  });

  const contentClasses = computed(() => {
    return ['card__content', config.value.content.base, props.class]
      .filter(Boolean)
      .join(' ');
  });
</script>

<template>
  <div :class="contentClasses">
    <slot />
  </div>
</template>
